var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemittanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5703 2.92998L10.9063 13.5939M3.771 8.23566L20.3769 2.47443C21.3995 2.11964 22.3807 3.10076 22.0259 4.1234L16.2646 20.7293C15.87 21.8669 14.2725 21.8981 13.8337 20.7768L11.1968 14.038C11.0651 13.7015 10.7988 13.4352 10.4623 13.3035L3.72354 10.6666C2.60219 10.2278 2.63338 8.63034 3.771 8.23566Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemittanceIcon);
export default __webpack_public_path__ + "static/media/remittance-icon.c1d26a54459d3a58dc6d7d73bbbaa25e.svg";
export { ForwardRef as ReactComponent };